import { StatusApi, type Status } from '#api/statusApi.ts';

const cache = new Map<number, Promise<Status[]>>();

/**
 * A client's statuses, fetched once per tab and shared by every caller until {@link invalidateClientStatuses}.
 * `refresh` refetches and replaces the shared entry, for callers that can't act on another session's stale list.
 */
export function getClientStatuses(clientId: number, { refresh = false } = {}): Promise<Status[]> {
    const cached = cache.get(clientId);
    if (cached && !refresh) return cached;

    const statuses = fetchStatuses(clientId);
    cache.set(clientId, statuses);
    statuses.catch(() => {
        if (cache.get(clientId) === statuses) cache.delete(clientId);
    });
    return statuses;
}

export function invalidateClientStatuses() {
    cache.clear();
}

async function fetchStatuses(clientId: number) {
    const result = await new StatusApi().list({ clientId, limit: 1000 });
    if (!result.data) throw new Error(`Could not load statuses for client ${clientId}.`);
    return result.data.results;
}
